import React, { useId } from 'react';
import styles from './LogoLoader.module.css';

interface LogoLoaderProps {
    size?: number;
    color?: string;
}

export const LogoLoader: React.FC<LogoLoaderProps> = ({
    size = 40,
    color = 'var(--color-text)'
}) => {
    const uniqueId = useId();
    const gradientId = `loader-gradient-${uniqueId.replace(/:/g, '')}`;

    return (
        <span className={styles.wrapper} style={{ width: `${size}px`, height: `${size}px` }}>
            <svg
                className={styles.svg}
                viewBox="0 0 248.16 219.8"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop className="gradient-stop-1" offset="0%" stopColor="var(--color-text-disabled)" stopOpacity="0.2" />
                        <stop className="gradient-stop-2" offset="100%" stopColor={color} stopOpacity="1" />
                    </linearGradient>
                </defs>
                <path
                    fill={`url(#${gradientId})`}
                    d="m247.98,100.15c-.08-55.31-41.87-100.15-93.41-100.15h-61.05C41.91,0,.08,44.91,.08,100.28h78.62C34.83,102.89,0,141.9,0,189.66v30.14h248.16v-119.67h-.18v.02Z"
                />
            </svg>
        </span>
    );
};

export default LogoLoader;